module.exports = __webpack_public_path__ + "static/media/share_with_doctor.c645b5cc.svg";